"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllBar = SelectAllBar;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 3 Nov 2026 · *Összes kijelölése / Kijelölés törlése* — every multi filter.  │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The product owner's ruling with the multi-select filters: each one carries both, so twelve
 * statuses minus two is two clicks and a tick each rather than ten ticks. One row, shared by the
 * list toolbar's multi panel and `MultiSelect`, so the two read as one control.
 *
 * ⚠️ **"Select all" takes what is SHOWN** — with a search typed, the matches; that is what the
 * person is looking at, and choosing what they cannot see would be a surprise. It ADDS to the
 * choice rather than replacing it, so a search for a second group extends the first.
 *
 * ⚠️ Each button is disabled when it would change nothing, rather than hidden: a row that comes and
 * goes moves the options under the pointer.
 */
function SelectAllBar({ shown, chosen, onChange, selectAll, deselectAll, }) {
    const missing = shown.filter((value) => !chosen.includes(value));
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-between gap-2 border-b px-2 py-1", children: [(0, jsx_runtime_1.jsx)("button", { type: "button", disabled: missing.length === 0, onClick: () => {
                    onChange([...chosen, ...missing]);
                }, className: "text-primary rounded-sm px-1 py-0.5 text-[12px] font-medium outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-default disabled:text-muted-foreground disabled:no-underline", children: selectAll }), (0, jsx_runtime_1.jsx)("button", { type: "button", disabled: chosen.length === 0, onClick: () => {
                    onChange([]);
                }, className: "text-primary rounded-sm px-1 py-0.5 text-[12px] font-medium outline-none hover:underline focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-default disabled:text-muted-foreground disabled:no-underline", children: deselectAll })] }));
}
//# sourceMappingURL=select-all-bar.js.map